import React, { useEffect, useState } from 'react';

const imageUrl = value => {
  if (typeof value !== 'string') return '';
  if (/^https:\/\/[^\s]+$/i.test(value)) return value;
  if (/^\/uploads\/[a-zA-Z0-9_./-]+$/.test(value)) return `${process.env.REACT_APP_IMAGE_URL || ''}${value}`;
  return '';
};
const ordered = values => (values || []).filter(value => Number(value.status) === 1).slice()
  .sort((a, b) => (Number(a.orderList) || 0) - (Number(b.orderList) || 0) || Number(a.id) - Number(b.id));

function PreviewImage({ src, title }) {
  const [failed, setFailed] = useState(false);
  useEffect(() => setFailed(false), [src]);
  return src && !failed ? <img src={src} alt={title} onError={() => setFailed(true)} style={{ display: 'block', width: '100%', height: 'auto' }} /> :
    <div style={{ aspectRatio: '1 / 1', display: 'flex', flexDirection: 'column', justifyContent: 'center', textAlign: 'center', background: '#f5f0f8', color: '#542654', padding: 8, fontSize: 12, overflowWrap: 'anywhere' }}><strong>{title}</strong><span>{failed ? 'Image could not load' : 'Upload image'}</span></div>;
}

export default function ImageSectionPreview({ section }) {
  const isBanner = Number(section.secType) === 1;
  const [joined, setJoined] = useState(true);
  const [showTitles, setShowTitles] = useState(false);
  const rows = ordered(section.mobrow);
  const merged = isBanner && joined;
  const banner = imageUrl(section.bannerImg);
  return <section aria-label={isBanner ? 'Banner section preview' : 'Product card section preview'} style={{ maxWidth: 420, width: '100%', margin: '12px auto' }}>
    <div className="small text-muted mb-2">Mobile layout preview · saved images and enabled items{Number(section.status) !== 1 ? ' · Section is inactive' : ''}</div>
    <div className="d-flex flex-wrap gap-3 small mb-2">
      {isBanner && <label><input type="checkbox" checked={joined} onChange={event => setJoined(event.target.checked)} /> Join banner images without gaps</label>}
      <label><input type="checkbox" checked={showTitles} onChange={event => setShowTitles(event.target.checked)} /> Show item titles below images</label>
    </div>
    <div style={{ border: '1px solid #e8deed', borderRadius: 16, overflow: 'hidden', background: '#fff' }}>
      {(section.title || Number(section.seeAll) === 1) && <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, padding: '14px 12px', color: '#260b27' }}>
        <strong style={{ fontSize: 20, overflowWrap: 'anywhere', minWidth: 0 }}>{section.title}</strong>
        {Number(section.seeAll) === 1 && <span style={{ whiteSpace: 'nowrap', fontSize: 12 }}>See all ›</span>}
      </div>}
      {banner && <PreviewImage src={banner} title="Section banner" />}
      <div style={{ padding: merged ? 0 : 10 }}>
        {rows.length === 0 && <div className="small text-muted p-3">Add an enabled row and upload images to see the layout.</div>}
        {rows.map(row => {
          const columns = Math.max(1, Math.min(8, Math.floor(Number(row.noofcols) || 1)));
          const items = ordered(row.mobdata);
          return <div key={row.id} aria-label={row.title || 'Image row'} style={{ display: 'grid', gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`, gap: merged ? 0 : 8, marginBottom: merged ? 0 : 10 }}>
            {items.length === 0 ? <div className="small text-muted p-3" style={{ gridColumn: '1 / -1' }}>This row has no enabled images.</div> : items.map(item => <div key={item.id} style={{ minWidth: 0 }}>
              <PreviewImage src={imageUrl(item.valueData)} title={item.title || 'Uploaded card'} />
              {showTitles && item.title && <div style={{ color: '#260b27', textAlign: 'center', fontSize: 12, padding: '4px 2px', overflowWrap: 'anywhere' }}>{item.title}</div>}
            </div>)}
          </div>;
        })}
      </div>
    </div>
    <div className="small text-muted mt-2">Preview controls only; they do not change saved settings. Titles are hidden by default because your artwork includes text.{isBanner ? ' For a merged banner, use equal-size pieces and two columns per row. The mobile app must also remove gaps and inner corner rounding.' : ' Images retain their original proportions, including text inside the image.'}</div>
  </section>;
}
